import NewModal from "../../shared/NewModal";
import crudApi from "@serie3/common/api/crudApi";
import GroupConfig from "@serie3/common/Modules/Groups/Resources/Endpoints";
import { useState, useEffect } from "react";
import { Button, Card, CardHeader } from "react-bootstrap";
import MediaplannerGroupEndpoints from "@serie3/mymediaplanner/Modules/Groups/endpoints";
import { toast } from "react-toastify";

const ShareModal = ({ show, setShow, sharePostId }) => {
  const [groups, setGroups] = useState([]);

  useEffect(() => {
    const getGroups = async () => {
      let response = await crudApi.justGet(GroupConfig.endpoints.list);
      if (response.ok) {
        setGroups(response.data);
      }
    };

    getGroups();
  }, []);

  const title = "Share Post in Group";

  const share = async (sharePostId, groupId) => {
    const url =
      MediaplannerGroupEndpoints.endpoints.sharePost + groupId + "/" + sharePostId;
    const response = await crudApi.justGet(url);

    if (response.ok) {
      toast.success("Post shared successfully");
    }
  };

  return (
    <NewModal show={show} setShow={setShow} title={title}>
      {groups.map((group, index) => {
        return (
          <Card>
            <CardHeader className="d-flex justify-content-between align-items-center">
              <b>{group.name}</b>
              <Button onClick={() => share(sharePostId, group.id)}>
                Share
              </Button>
            </CardHeader>
          </Card>
        );
      })}
    </NewModal>
  );
};

export default ShareModal;
